import React from 'react';
import PropTypes from 'prop-types';
import { openTab } from '../../../src/utils/openTab';
import FSFlatButton from '../../../src/components/lib/FSFlatButton';

const CiriumMobileImage = '//assets.flightstats.com/v2/home/Cirium2021-plane.jpg';
const CiriumLink = 'https://www.cirium.com/who-we-are/2020-airline-insights-review/?cmpid=PLC|brand|CIJHR-12-2020-Airline-Review-2020';

const title = 'The Cirium Airline Insights Review 2020';
const subtitle = 'Review our detailed trends and analysis of aviation and air travel';

const CiriumSection = (props) => {
  const {
    reportButtonPress,
  } = props;

  return (
    <div className='homepage-cirium-section'>
      <div className='homepage-cirium-section-container'>
        <div
          className='homepage-cirium-section-mobile-image'
          style={{ backgroundImage: `url(${CiriumMobileImage})` }}
          alt='Cirium-Aviation-Outlook-2021'
        />
        <div className='homepage-cirium-section-right-col'>
          <div className='homepage-cirium-section-right-col-container'>
            <div className='homepage-cirium-text-container'>
              <h3>{title}</h3>
              <h4>{subtitle}</h4>
            </div>
            <div className='homepage-cirium-button-container'>
              <FSFlatButton
                href={CiriumLink}
                backgroundColor='#00856C'
                label='DOWNLOAD THE REVIEW'
                onClick={(e) => {
                  e.preventDefault();
                  reportButtonPress('CiriumAviationReview2021');
                  openTab(CiriumLink);
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

CiriumSection.propTypes = {
  reportButtonPress: PropTypes.func,
};

export default CiriumSection;



// WEBPACK FOOTER //
// ./modules/Homepage/components/CiriumSection.js